<template>
  <div class="app-container">
    <el-button
      type="primary"
      @click="addMenu(0)"
      style="margin-bottom: 5px"
      v-if="roles.includes('/business/add_advantages')"
      >添加</el-button
    >
    <el-table
      max-height="700"  v-loading="listLoading" 
      :data="list"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="优势名称">
        <template slot-scope="scope">
          <div class="line2" v-if="scope.row.title">{{ scope.row.title }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="260" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/business/edit_advantages')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/business/advantages_del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="优势名称" prop="title">
          <el-input
            class="w4"
            v-model="ruleForm.title"
            placeholder="请输入优势名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="优势图片" prop="thumb">
          <el-upload
            name="file[]"
            
            :data="{ type: 'image' }"
            :action="ossUpload"
            accept=".jpg,.png,.jpeg"
            :headers="{ token: token }"
            list-type="picture-card"
            :show-file-list="true"
            :limit="1"
            :on-exceed="exceed"
            :file-list="fileList"
            :on-remove="handleRemovePic"
            :on-success="handleAvatarSuccess"
            :disabled="cztype == 'see'"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input
            class="w4 numInput"
            v-model="ruleForm.sort"
            placeholder="请输入排序"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="优势介绍详情" prop="content">
          <Editor
            ref="myQuillEditor"
            style="width: 100%"
            v-model="ruleForm.content"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import {
  advantages_lists,
  add_advantages,
  advantages_info,
  edit_advantages,
  advantages_del,
} from "@/api/investment";
import { openPark, delImage } from "@/api/index";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        page: 1,
        page_size: 15,
        // park_id: "",
        // type_id: "",
        // title: "",
      },
      total: 0,
      ruleForm: {},
      fileList: [],
      rules: {
        thumb: [{ required: true, message: "请选择优势图片" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        title: [{ required: true, message: "请输入优势名称", trigger: "blur" }],
        content: [
          { required: true, message: "请输入优势介绍", trigger: "blur" },
        ],
      },
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      clearPics: [],
      percentage: 0,
      percentageShow: true,
      clearVideos: [],
    };
  },
  created() {
    // if (this.userInfo.park_id !== 0) {
    //   this.screen.park_id = this.userInfo.park_id;
    // } else {
    //   this.screen.park_id = "";
    // }
    this.fetchData();
    // this.getPark();
    // this.getTypes();
  },
  methods: {
    exceed() {
      this.$message.warning("图片仅限一张，请先移除原有图片！");
    },
    handleRemovePic(file, fileList) {
      if (file.response.data.url) {
        this.clearPics.push(file.response.data.url);
      }
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.ruleForm.thumb = list.join(",");
    },
    delImges() {
      if (this.clearPics.length) {
        delImage({ file: this.clearPics.join(",") }).then((ress) => {});
      }
      if (this.clearVideos.length) {
        delImage({ file: this.clearVideos.join(",") }).then((ress) => {});
      }
    },
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        this.ruleForm.thumb = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
    },
    reset() {
      this.screen = {
        page: 1,
        page_size: 15,
      };
      // if (this.userInfo.park_id !== 0) {
      //   this.screen.park_id = this.userInfo.park_id;
      // } else {
      //   this.screen.park_id = "";
      // }
      this.fetchData();
      // this.getTypes();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              edit_advantages(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.delImges();
                  that.drawer = false;
                  that.$refs.ruleForm.clearValidate();
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.clearPics = [];
      this.fileList = [];
      this.clearVideos = [];
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      // this.ruleForm = val
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      advantages_info({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.ruleForm = {
          id: res.data.info.id,
          title: res.data.info.title,
          thumb: res.data.info.thumb,
          sort: res.data.info.sort,
          content: res.data.info.content,
        };
        var list = res.data.info.thumb.split(",");
        this.fileList = list.map((item) => {
          return {
            name: +new Date(),
            url: this.imageOss + item,
            response: {
              data: {
                url: item,
              },
            },
          };
        });
      });
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          advantages_del({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              add_advantages(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.delImges();
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$refs.ruleForm.clearValidate();
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        title: "",
        thumb: "",
        sort: 0,
        content: "",
      };
      this.fileList = [];
      this.clearPics = [];
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      advantages_lists(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
